import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, element, space, attr, insert, append, check_outros, detach, component_subscribe, group_outros } from '../../external_node_modules/svelte/internal/index.mjs.js';
import Loader from '../shared/components/Loader/Loader.svelte.js';
import PurchaseResult from './PurchaseResult.svelte.js';
import ConfirmPurchase from './ConfirmPurchase.svelte.js';
import isLoading, { setLoading } from '../../store/isLoading.js';
import purchaseResult from '../../store/purchaseResult.js';
import purchaseTwoFactor from '../../store/purchaseTwoFactor.js';

/* src/ui/PurchaseProduct/App.svelte generated by Svelte v3.44.2 */

function create_if_block_2(ctx) {
	let confirmpurchase;
	let current;

	confirmpurchase = new ConfirmPurchase({
			props: {
				closeApplication: /*closeApplication*/ ctx[0]
			}
		});

	return {
		c() {
			create_component(confirmpurchase.$$.fragment);
		},
		m(target, anchor) {
			mount_component(confirmpurchase, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const confirmpurchase_changes = {};
			if (dirty & /*closeApplication*/ 1) confirmpurchase_changes.closeApplication = /*closeApplication*/ ctx[0];
			confirmpurchase.$set(confirmpurchase_changes);
		},
		i(local) {
			if (current) return;
			transition_in(confirmpurchase.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(confirmpurchase.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(confirmpurchase, detaching);
		}
	};
}

// (16:2) {#if $isLoading}
function create_if_block_1(ctx) {
	let loader;
	let current;
	loader = new Loader({});

	return {
		c() {
			create_component(loader.$$.fragment);
		},
		m(target, anchor) {
			mount_component(loader, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(loader.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(loader.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(loader, detaching);
		}
	};
}

// (19:2) {#if $purchaseResult}
function create_if_block(ctx) {
	let purchaseresult;
	let current;

	purchaseresult = new PurchaseResult({
			props: {
				purchaseResult: /*purchaseResultData*/ ctx[2],
				closeApplication: /*closeApplication*/ ctx[0]
			}
		});

	return {
		c() {
			create_component(purchaseresult.$$.fragment);
		},
		m(target, anchor) {
			mount_component(purchaseresult, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const purchaseresult_changes = {};
			if (dirty & /*purchaseResultData*/ 4) purchaseresult_changes.purchaseResult = /*purchaseResultData*/ ctx[2];
			if (dirty & /*closeApplication*/ 1) purchaseresult_changes.closeApplication = /*closeApplication*/ ctx[0];
			purchaseresult.$set(purchaseresult_changes);
		},
		i(local) {
			if (current) return;
			transition_in(purchaseresult.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(purchaseresult.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(purchaseresult, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let t0;
	let t1;
	let current;
	let if_block0 = /*$purchaseTwoFactor*/ ctx[3].isVisibleConfirmPurchasePopup && create_if_block_2(ctx);
	let if_block1 = /*$isLoading*/ ctx[4] && create_if_block_1();
	let if_block2 = /*$purchaseResult*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			attr(div, "class", "app");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			if (if_block1) if_block1.m(div, null);
			append(div, t1);
			if (if_block2) if_block2.m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$purchaseTwoFactor*/ ctx[3].isVisibleConfirmPurchasePopup) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*$purchaseTwoFactor*/ 8) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$isLoading*/ ctx[4]) {
				if (if_block1) {
					if (dirty & /*$isLoading*/ 16) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1();
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*$purchaseResult*/ ctx[1]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*$purchaseResult*/ 2) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let purchaseResultData;
	let $purchaseResult;
	let $purchaseTwoFactor;
	let $isLoading;
	component_subscribe($$self, purchaseResult, $$value => $$invalidate(1, $purchaseResult = $$value));
	component_subscribe($$self, purchaseTwoFactor, $$value => $$invalidate(3, $purchaseTwoFactor = $$value));
	component_subscribe($$self, isLoading, $$value => $$invalidate(4, $isLoading = $$value));
	let { closeApplication } = $$props;
	setLoading(true);

	$$self.$$set = $$props => {
		if ('closeApplication' in $$props) $$invalidate(0, closeApplication = $$props.closeApplication);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$purchaseResult*/ 2) {
			$$invalidate(2, purchaseResultData = $purchaseResult);
		}
	};

	return [
		closeApplication,
		$purchaseResult,
		purchaseResultData,
		$purchaseTwoFactor,
		$isLoading
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { closeApplication: 0 });
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
